module.exports = __webpack_public_path__ + "static/media/aq.54cf99ae.svg";